module.exports = __webpack_public_path__ + "static/media/6_Prepare-Back-Cable-Connector.8614741c.svg";